import { TaskGroupType } from '@app/domain/entities/task-group-type.entity';
import { TaskGroupTypeDTO } from '../dtos/task-group-type.dto';

export class TaskGroupTypeMapper {
  taskGroupTypeListItemToDomain(dto: TaskGroupTypeDTO): TaskGroupType {
    return {
      id: dto.id,
      isEditable: dto.isEditable,
      taskGroupTypeName: dto.taskGroupTypeName,
    };
  }

  taskGroupTypeListItemsToDomain(dtos: TaskGroupTypeDTO[]): TaskGroupType[] {
    return dtos.map(dto => this.taskGroupTypeListItemToDomain(dto));
  }
}
